import { User } from './user';

export class ToolManagementValidation {

  constructor(
    public hash?: string,
    public date?: number,
    public quantity?: number,
    public isSent?: boolean,
    public isRebuild?: boolean,
    public user?: User,
    public toolManagementHash?: string,
    public toolManagementName?: string,
    public toolManagementStock?: number,
    public toolManagementRequestQuantity?: number,
    public toolManagementOrderQuantity?: number,
    public toolManagementErpCode?: string,
    public toolManagementOptionHash?: string,
    public toolManagementOptionName?: string,
    public toolManagementOptionStockNumber?: number,
    public toolManagementOptionRequestQuantity?: number,
    public toolManagementOptionOrderQuantity?: number,
  ) { }

  get optionStockNumber() {
    return this.toolManagementOptionStockNumber ? '(' + this.toolManagementOptionStockNumber + ')' : null;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-management-validation.ts